/**
 * The canonical tokens the standard vocabulary binds the chrome directives
 * to (D179) — a leaf module, imported by both the conversation wrapper and
 * the HELP handler, because the two sit on opposite sides of the turn
 * pipeline and a table shared through either would close an import cycle.
 *
 * @packageDocumentation
 */

/** The canonical tokens, by directive. D226 (E12) adds `again` — `g`, `repeat`: say the last thing again. */
export const CHROME_DIRECTIVE_TOKENS = {
	again: 'again',
	load: 'load',
	restart: 'restart',
	save: 'save',
} as const;

/** One chrome directive, by the intent that names it. */
export type ChromeDirective = keyof typeof CHROME_DIRECTIVE_TOKENS;

/**
 * The canonical token the standard vocabulary binds the withdrawal words to
 * (R34) — read whole-input like the chrome directives, before any parse.
 * Lives here beside them so the one list of "tokens the engine claims before
 * the roster ever sees them" has a single home (D196 reads it).
 */
export const WITHDRAWAL_INTENT_TOKEN = 'nevermind';
